<app-dialog-header
    title="Are you sure you want to send this email?"
></app-dialog-header>

<app-dialog-footer
    [posButtonText]="'Confirm'"
    (buttonClick)="onClickYes()"
    (closeClick)="onClickNo()"
></app-dialog-footer>
